/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    errorCard: {
      maxWidth: theme.spacing(60),
      width: '100%',
      margin: 'auto',
    },
    errorCardContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    errorCardImage: {
      marginBottom: theme.spacing(1),
      maxWidth: theme.spacing(35),
      '& svg,& img': {
        width: '100%',
        maxWidth: '100%',
        height: 'auto',
        display: 'block',
      },
    },
    errorCardTitle: {
      marginTop: theme.spacing(1),
      textAlign: 'center',
    },
    errorCardDescription: {
      marginTop: theme.spacing(1),
      textAlign: 'center',
    },
    errorCardChildren: {
      marginTop: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center',
    },
    errorCardAction: {
      marginTop: theme.spacing(2),
    },
    errorCodeMessage: {
      display: 'flex',
      alignItems: 'center',
    },
    errorCodeIcon: {
      color: theme.palette.error.main,
      marginRight: theme.spacing(1),
    },
    errorCodeTypo: {
      display: 'flex',
      alignItems: 'center',
    },
    errorCode: {
      color: theme.palette.error.main,
      marginRight: theme.spacing(0.5),
    },
    errorMessage: {
      color: theme.palette.error.main,
    },
    infoListItem: {
      display: 'flex',
      alignItems: 'flex-start',
      textAlign: 'left',
      marginBottom: theme.spacing(1),
    },
    infoListItemIcon: {
      marginRight: theme.spacing(1),
      paddingTop: theme.spacing(0.6),
    },
    infoListItemMessage: {},
  })
);

export default useStyles;
